import React from "react";
import { StyledBanner, StyledBannerContainer, StyledCorner, StlyedBannerTitle } from "../style";
import DashedBanner from "./DashedBanner";

interface BannerProps {
  title: string;
  imageUrl?: string;
}
function Banner({ title, imageUrl }: BannerProps) {
  return (
    <StyledBannerContainer>
      <StyledBanner>
        <StyledCorner className="conner-left" />
        <div className="image-container">
          <div className="dashed-container">
            <div className="dashed">
              <DashedBanner />
            </div>
            {imageUrl && <img className="image" src={imageUrl} alt="brand" />}
          </div>
          <StlyedBannerTitle>{title}</StlyedBannerTitle>
        </div>
        <StyledCorner className="conner-rigth" />
      </StyledBanner>
    </StyledBannerContainer>
  );
}

export default Banner;
